import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.0_@azure+identity@4.11.1_@parcel+watcher@2.5.1_@types+node@20.5.1_@vue+compil_ef1adb280084d0d666139f3f0ec454ca/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}